<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/task_category/data',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Judul',
              width: '400px',
              value: 'title',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'is_kpi_bool',
              freeze: false,
              hide: false,
              format: 'kpi'
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'title',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Aktifitas',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'is_kpi_bool',
              label: 'Tipe',
              type: 'select',
              placeholder: 'Contoh. Umum',
              value: '',
              option: [
                {
                  text: 'Untuk KPI',
                  value: true
                },
                {
                  text: 'Umum',
                  value: false
                }
              ],
              width: '50%',
              required: true,
              rules: 'required'
            }
          ],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/task_category/add',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/task_category/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'admin/task_category/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>